import { render } from "./CreateExternalClinicService.vue?vue&type=template&id=6fa5e422&scoped=true"
import script from "./CreateExternalClinicService.vue?vue&type=script&lang=js"
export * from "./CreateExternalClinicService.vue?vue&type=script&lang=js"

import "./CreateExternalClinicService.vue?vue&type=style&index=0&id=6fa5e422&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa5e422"]])

export default __exports__